import React, { useRef } from 'react'
import { components, constants, useTranslation } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import AceHighwayAbiInbond7512Keys from 'src/constants/locale/key/AceHighwayAbiInbond7512'
import BolContainerFormProperties from './BolContainerFormProperties'
import CngSection from '../../../components/cngcomponents/CngSection'
import CngSubSection from 'src/components/cngcomponents/CngSubSection'
import CollapsibleSection from 'src/components/ui/CollapsibleSection'
import CngField from '../../../components/cngcomponents/CngField'
import TinyChip from '../../../components/aciacehighway/TinyChip'
import { useFormContext } from 'react-hook-form'
import { Box, Divider, Grid, Typography } from '@material-ui/core'
import ACEHighwayManifestTranslationText from '../contexts/ACEHighwayManifestTranslationText'
import ACEHighwayInbond7512TranslationText from '../contexts/ACEHighwayInbond7512TranslationText'

const {
  button: { CngButton, CngPrimaryButton },
  form: { CngForm },
  CngDialog
} = components

const { FormState } = constants

function BolContainerDialog(props) {
  const {
    bolContainer,
    isView,
    onClose,
    open,
    showNotification,
    ftz,
    entryType
  } = props

  const { initialValues, makeValidationSchema } =
    BolContainerFormProperties.formikProps

  const lastIndex = useRef(isView ? null : 0)
  const formContext = useFormContext()
  const { translate } = useTranslation(Namespace.ACE_HIGHWAY_ABI_INBOND_7512)
  const translatedTextsObject = ACEHighwayInbond7512TranslationText()
  const manifestTranslatedTextsObject = ACEHighwayManifestTranslationText()

  function handleAddBolContainer(data) {
    const bolContainer = [...formContext.getValues('bolContainer'), data].map(
      (bolContainer) => ({
        ...bolContainer,
        _id: ++lastIndex.current
      })
    )

    formContext.setValue('bolContainer', bolContainer, { shouldValidate: true })
    onClose()
  }

  function handleEditBolContainer(data) {
    const bolContainer = [...formContext.getValues('bolContainer')]
    const index = bolContainer.findIndex((bolContainer) =>
      data.id ? bolContainer.id === data.id : bolContainer._id === data._id
    )

    formContext.setValue(`bolContainer.${index}`, data, {
      shouldValidate: true
    })
    onClose()
  }

  if (!open) {
    return null
  }

  let viewContent = bolContainer && (
    <CngSection title='Classification &amp; weight'>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12} md={4} />
            <Grid item xs={12} md={8}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <CngField label={translatedTextsObject.containerNumber}>
                    {bolContainer.containerNumber}
                  </CngField>
                </Grid>
                <Grid item xs={6}>
                  <CngField label={translatedTextsObject.sealNumber1}>
                    {bolContainer.sealNumber1}
                  </CngField>
                </Grid>
                <Grid item xs={6}>
                  <CngField label={translatedTextsObject.sealNumber2}>
                    {bolContainer.sealNumber2}
                  </CngField>
                </Grid>
                <Grid item xs={6}>
                  <CngField label={translatedTextsObject.containerDescriptionCode}>
                    {bolContainer.containerDescriptionCode}
                  </CngField>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <CngSubSection title={translatedTextsObject.billCargoDesc}>
            {bolContainer.billCargoDesc.length > 0 ? (
              <Grid container spacing={2}>
                {bolContainer.billCargoDesc.map((cargoDesc, index) => (
                  <React.Fragment key={Math.random()}>
                    <Grid item xs={12}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                          <CngField label={translatedTextsObject.pieceCount}>
                            {cargoDesc.pieceCount}
                          </CngField>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <CngField label={translatedTextsObject.description}>
                            {cargoDesc.description}
                          </CngField>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <CngField label={translatedTextsObject.manifestUnitCode}>
                            {cargoDesc.manifestUnitCode}
                          </CngField>
                        </Grid>
                      </Grid>
                    </Grid>
                    {bolContainer.billCargoDesc.length !== index + 1 && (
                      <Grid item xs={12}>
                        <Divider />
                      </Grid>
                    )}
                  </React.Fragment>
                ))}
              </Grid>
            ) : (
              <Typography variant='body2' color='textSecondary'>
                {manifestTranslatedTextsObject.noRecordsToDisplay}
              </Typography>
            )}
          </CngSubSection>
        </Grid>
        <Grid item xs={12}>
          <CngSubSection title={translatedTextsObject.htsInformation}>
            {bolContainer.htsInformation.length > 0 ? (
              <Grid container spacing={2}>
                {bolContainer.htsInformation.map((hts, index) => (
                  <React.Fragment key={Math.random()}>
                    <Grid item xs={12}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                          <CngField label={translatedTextsObject.harmonizedNumber}>
                            {hts.harmonizedNumber}
                          </CngField>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <CngField label={translatedTextsObject.htsValue}>
                            {hts.value}
                          </CngField>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <CngField label={`${translatedTextsObject.htsWeight} & ${translatedTextsObject.htsWeightUom}`}>
                            <Typography component='div' variant='inherit'>
                              {hts.weight}
                              <TinyChip label={hts.weightUnit} />
                            </Typography>
                          </CngField>
                        </Grid>
                      </Grid>
                    </Grid>
                    {bolContainer.htsInformation.length !== index + 1 && (
                      <Grid item xs={12}>
                        <Divider />
                      </Grid>
                    )}
                  </React.Fragment>
                ))}
              </Grid>
            ) : (
              <Typography variant='body2' color='textSecondary'>
                {manifestTranslatedTextsObject.noRecordsToDisplay}
              </Typography>
            )}
          </CngSubSection>
        </Grid>
        <Grid item xs={12}>
          <CngSubSection title={translatedTextsObject.marksAndNumbersTitle}>
            {bolContainer.marksAndNumbers.length > 0 ? (
              <Grid container spacing={2}>
                {bolContainer.marksAndNumbers.map((marks, index) => (
                  <React.Fragment key={Math.random()}>
                    <Grid item xs={12}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                          <CngField label={translatedTextsObject.marksAndNumbers}>
                            {marks.marksAndNumbers}
                          </CngField>
                        </Grid>
                      </Grid>
                    </Grid>
                    {bolContainer.marksAndNumbers.length !== index + 1 && (
                      <Grid item xs={12}>
                        <Divider />
                      </Grid>
                    )}
                  </React.Fragment>
                ))}
              </Grid>
            ) : (
              <Typography variant='body2' color='textSecondary'>
                {manifestTranslatedTextsObject.noRecordsToDisplay}
              </Typography>
            )}
          </CngSubSection>
        </Grid>
        <Grid item xs={12}>
          <CngSubSection title={translatedTextsObject.hazmatInformation}>
            {bolContainer.hazmatInformation.length > 0 ? (
              <Grid container spacing={2}>
                {bolContainer.hazmatInformation.map((hazmat, index) => (
                  <React.Fragment key={Math.random()}>
                    <Grid item xs={12}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                          <CngField label={translatedTextsObject.hazardousMaterialCode}>
                            {hazmat.hazardousMaterialCode}
                          </CngField>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <CngField label={translatedTextsObject.hazardousMaterialClass}>
                            {hazmat.hazardousMaterialClass}
                          </CngField>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <CngField label={translatedTextsObject.hazardousMaterialCodeQual}>
                            {hazmat.hazardousMaterialCodeQual}
                          </CngField>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <CngField label={translatedTextsObject.hazardousMaterialDescription}>
                            {hazmat.hazardousMaterialDescription}
                          </CngField>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <CngField label={translatedTextsObject.hazardousMaterialContact}>
                            {hazmat.hazardousMaterialContact}
                          </CngField>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <CngField label={`${translatedTextsObject.flashpointTemperature} & ${translatedTextsObject.uomCode}`}>
                            <Typography component='div' variant='inherit'>
                              {hazmat.negativeIndicator ? "-" : "+"}{hazmat.flashpointTemperature}
                              <TinyChip label={hazmat.uomCode} />
                            </Typography>
                          </CngField>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <CngField label={translatedTextsObject.hazardousMaterialDescription1}>
                            {hazmat.hazardousMaterialDescription1}
                          </CngField>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <CngField label={translatedTextsObject.hazardousMaterialClassification1}>
                            {hazmat.hazardousMaterialClassification1}
                          </CngField>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <CngField label={translatedTextsObject.hazardousMaterialDescription2}>
                            {hazmat.hazardousMaterialDescription2}
                          </CngField>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <CngField label={translatedTextsObject.hazardousMaterialClassification2}>
                            {hazmat.hazardousMaterialClassification2}
                          </CngField>
                        </Grid>
                      </Grid>
                    </Grid>
                    {bolContainer.hazmatInformation.length !== index + 1 && (
                      <Grid item xs={12}>
                        <Divider />
                      </Grid>
                    )}
                  </React.Fragment>
                ))}
              </Grid>
            ) : (
              <Typography variant='body2' color='textSecondary'>
                {manifestTranslatedTextsObject.noRecordsToDisplay}
              </Typography>
            )}
          </CngSubSection>
        </Grid>
      </Grid>
    </CngSection>
  )

  return (
    <CngDialog
      dialogContent={
        bolContainer && isView ? (
          viewContent
        ) : (
          <CngForm
            fieldLevel='form'
            formikProps={{
              initialValues: bolContainer || initialValues,
              makeValidationSchema: makeValidationSchema,
              onSubmit: (data) => {
                if (bolContainer) {
                  handleEditBolContainer(data)
                } else {
                  handleAddBolContainer(data)
                }
              }
            }}
            formState={FormState.COMPLETED}
            innerForm={true}
            renderBodySection={(labelMap, shouldHideMap) => (
              <BolContainerFormProperties.Fields
                showNotification={showNotification}
                shouldHideMap={shouldHideMap}
                ftz={ftz}
                entryType={entryType}
              />
            )}
            renderButtonSection={() => (
              <Box display='flex' justifyContent='flex-end'>
                <CngPrimaryButton
                  type='submit'
                  disabled={
                    formContext ? formContext.formState.isSubmitting : false
                  }
                >
                  {bolContainer
                    ? translatedTextsObject.updateButton
                    : translatedTextsObject.saveButton}
                </CngPrimaryButton>
              </Box>
            )}
          />
        )
      }
      dialogTitle={translatedTextsObject.bolContainer}
      dialogAction={
        isView ? <CngButton onClick={onClose}>OK</CngButton> : null
      }
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      fullWidth
      maxWidth='md'
      onClose={onClose}
      open={open}
      shouldShowCloseButton
    />
  )
}

export default BolContainerDialog
